import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e55ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-17 ant-col-xl-9" }
const _hoisted_3 = { class: "ant-col ant-col-xs-7 ant-col-xl-5" }
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_6 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"ant-col ant-col-xs-3 ant-col-xl-3\" data-v-13e55ffa><span class=\"ss-titulo-campo\" data-v-13e55ffa>Código</span></div><div class=\"ant-col\" style=\"flex:1 1 auto;\" data-v-13e55ffa><span class=\"ss-titulo-campo\" data-v-13e55ffa>Centro de Custo</span></div><div class=\"ant-col ant-col-xs-10 ant-col-xl-10\" data-v-13e55ffa><span class=\"ss-titulo-campo\" data-v-13e55ffa>Proporção</span></div>", 3)
const _hoisted_10 = {
  key: 0,
  class: "ant-col ant-col-xl-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "ant-col ant-col-xs-11 ant-col-xl-11" }
const _hoisted_14 = { class: "ss-margin-campos ss-campo-descricao" }
const _hoisted_15 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_16 = { class: "ss-margin-campos" }
const _hoisted_17 = { class: "ant-col ant-col-xs-7 ant-col-xl-5" }
const _hoisted_18 = { class: "ss-margin-campos" }
const _hoisted_19 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-3"
}
const _hoisted_20 = { class: "ss-margin-campos" }
const _hoisted_21 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, {
              label: "Centro de Custo",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_centro_custo, {
                  codigoSelecionado: _ctx.state.centroCustoSelecionado,
                  "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.centroCustoSelecionado) = $event)),
                  descricaoSelecionado: _ctx.state.descricaoCentroCustoSelecionado,
                  "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.descricaoCentroCustoSelecionado) = $event))
                }, null, 8, ["codigoSelecionado", "descricaoSelecionado"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Proporção",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_numerico, {
                  valor: _ctx.state.proporcao,
                  "onUpdate:valor": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.proporcao) = $event)),
                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.aoAlterarProporcao(_ctx.state.valor)))
                  ],
                  percentual: true
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Valor",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_numerico, {
                  valor: _ctx.state.valor,
                  "onUpdate:valor": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.valor) = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.aoAlterarValor(_ctx.state.valor)))
                  ],
                  percentual: false
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary",
                  style: {"width":"100%"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.adicionarCentroCusto && _ctx.adicionarCentroCusto(...args)))
                }, "Adicionar")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.props.editavel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    (_ctx.computedCentrosCusto.length <= 0)
      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
          key: 1,
          mensagem: "Nenhum centro de custo adicionado ainda"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.computedCentrosCusto, (centroCusto, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ant-row ss-grade-personalizada-linha",
            key: index
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_selecionar_centro_custo, {
                  codigoSelecionado: _ctx.computedCentrosCusto[index].codigoCentroCusto,
                  "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedCentrosCusto[index].codigoCentroCusto) = $event),
                  descricaoSelecionado: _ctx.computedCentrosCusto[index].descricaoCentroCusto,
                  "onUpdate:descricaoSelecionado": ($event: any) => ((_ctx.computedCentrosCusto[index].descricaoCentroCusto) = $event)
                }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_campo_numerico, {
                  valor: _ctx.computedCentrosCusto[index].proporcao,
                  percentual: true,
                  disabled: true,
                  "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => (_ctx.limparCampos()))
                }, null, 8, ["valor"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_campo_numerico, {
                  valor: _ctx.calcularValorMonetarioItem(_ctx.computedCentrosCusto[index].proporcao),
                  monetario: true,
                  disabled: true
                }, null, 8, ["valor"])
              ])
            ]),
            (_ctx.props.editavel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ss-botao-remover",
                      style: {"width":"100%"},
                      title: "Remover",
                      onClick: ($event: any) => (_ctx.removerCentroCusto(index)),
                      disabled: !_ctx.props.editavel
                    }, [
                      _createVNode(_component_icone, {
                        class: "ss-icone-remover",
                        nome: "excluir"
                      })
                    ], 8, _hoisted_21)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
  ], 64))
}